import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './ProdigyInputStyles.scss';

function ProdigyInput(props) {
  const {
    id,
    value,
    className,
    onChangeHandler,
    disabled,
    required,
    error,
    info,
    label,
    placeholder,
  } = props;

  return (
    <div
      className={classNames(
        'prodigy-input-container',
        error ? 'prodigy-input-container-error' : '',
        disabled ? 'prodigy-input-container-disabled' : '',
      )}
    >
      <label className="label">
        {label}
        {required && ' *'}
      </label>
      <input
        id={id}
        type="input"
        value={value}
        onChange={e => onChangeHandler(e.target.value)}
        className={className}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
      />
      {info && <span className="prodigy-input-info">{info}</span>}
      {error && error.msg && (
        <span className="prodigy-input-error">{error.msg}</span>
      )}
    </div>
  );
}

ProdigyInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChangeHandler: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.object,
  info: PropTypes.string,
};

export default ProdigyInput;
